// extracted by mini-css-extract-plugin
export default {"meal":"mealsitem_meal__CFDOT","description":"mealsitem_description__qXG1h","price":"mealsitem_price__BrD7F"};